<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="historyChange"
      scrollable
      size="xl"
      title="Historico de alteração"
    >
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="filterFields"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="filterFields[field.filterKey] != null">
                <b-form-input
                  v-if="field.key == 'dateChange'"
                  type="date"
                  v-model="filterFields[field.filterKey]"
                />
                <b-form-input
                  v-else
                  v-model="filterFields[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()"> Fechar </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ChecklistHistory",
  props: {
    id: String,
  },
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "changeField",
          filterKey: "changeField",
          label: this.$t("story.changedColumn"),
        },
        {
          key: "oldValue",
          filterKey: "oldValue",
          label: this.$t("story.oldValue"),
        },
        {
          key: "newValue",
          filterKey: "newValue",
          label: this.$t("story.newValue"),
        },
        {
          key: "dateChange",
          filterKey: "dateChange",
          label: this.$t("story.date"),
          thStyle: "min-width: 160px",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "displayUserName",
          filterKey: "displayUserName",
          label: this.$t("story.userDisplayName"),
          thStyle: "min-width: 250px",
        },
      ],
      filterFields: {
        dateChange: "",
        changeField: "",
        fieldName: "",
        oldValue: "",
        newValue: "",
        displayUserName: "",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        dateChange: ctx.filter.dateChange,
        changeField: ctx.filter.changeField,
        oldValue: ctx.filter.oldValue,
        newValue: ctx.filter.newValue,
        displayUserName: ctx.filter.displayUserName,
      };
      this.$apiChecklist
        .post("/checklistHistory/GetAllChange/" + this.id, apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>

